import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CoreServicesSection from './components/CoreServicesSection';
import CtaBanner from './components/CtaBanner';

const Home = () => {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

    const organizationSchema = {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '주식회사 에스지 SG SMART GEO',
      alternateName: 'SG SMART GEO',
      url: siteUrl,
      logo: {
        '@type': 'ImageObject',
        url: 'https://static.readdy.ai/image/00aed269fb1e179199d0d5bf56fc46fa/e4c97585502309238de2821b4122566a.png',
        width: 512,
        height: 512,
      },
      description:
        'SG SMART GEO는 지반조사, 계측, 정밀안전진단 데이터를 기반으로 생성형 AI 및 데이터 분석 기술을 활용하여 정확한 해석과 신뢰성 있는 의사결정을 지원하는 AI 기반 지반 데이터 분석 전문기업입니다.',
      address: {
        '@type': 'PostalAddress',
        streetAddress: '천년숲동로 46',
        addressLocality: '안동시',
        addressRegion: '경상북도',
        addressCountry: 'KR',
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: 36.5684,
        longitude: 128.7294,
      },
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        availableLanguage: '한국어',
        url: `${siteUrl}/contact`,
      },
      sameAs: [],
      knowsAbout: ['지반조사', '스마트 계측', '정밀안전진단', 'AI 기반 지반 데이터 분석'],
      foundingLocation: {
        '@type': 'Place',
        name: '경북 안동시',
        addressCountry: 'KR',
      },
    };

    const localBusinessSchema = {
      '@context': 'https://schema.org',
      '@type': 'LocalBusiness',
      name: '주식회사 에스지 SG SMART GEO',
      image: 'https://static.readdy.ai/image/00aed269fb1e179199d0d5bf56fc46fa/e4c97585502309238de2821b4122566a.png',
      url: siteUrl,
      description:
        'AI 기반 지반 데이터 분석, 스마트 계측, 지반조사, 정밀안전진단 전문기업. 경북 안동시 소재.',
      address: {
        '@type': 'PostalAddress',
        streetAddress: '천년숲동로 46',
        addressLocality: '안동시',
        addressRegion: '경상북도',
        postalCode: '36728',
        addressCountry: 'KR',
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: 36.5684,
        longitude: 128.7294,
      },
      areaServed: {
        '@type': 'Country',
        name: '대한민국',
      },
      priceRange: '문의',
      currenciesAccepted: 'KRW',
      paymentAccepted: '계좌이체',
      openingHoursSpecification: [
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
          opens: '09:00',
          closes: '18:00',
        },
      ],
    };

    const webSiteSchema = {
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: 'SG SMART GEO',
      url: siteUrl,
      inLanguage: 'ko',
      potentialAction: {
        '@type': 'SearchAction',
        target: {
          '@type': 'EntryPoint',
          urlTemplate: `${siteUrl}/?q={search_term_string}`,
        },
        'query-input': 'required name=search_term_string',
      },
    };

    const webPageSchema = {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: '주식회사 에스지 SG SMART GEO | AI 기반 지반 데이터 분석 스마트 계측 전문기업',
      url: siteUrl,
      description:
        'SG SMART GEO는 지반조사, 계측, 정밀안전진단 데이터를 기반으로 생성형 AI 및 데이터 분석 기술을 활용하여 정확한 해석과 신뢰성 있는 의사결정을 지원하는 AI 기반 지반 데이터 분석 전문기업입니다.',
      inLanguage: 'ko',
      dateModified: '2026-04-12',
      isPartOf: {
        '@type': 'WebSite',
        name: 'SG SMART GEO',
        url: siteUrl,
      },
      about: {
        '@type': 'Organization',
        name: '주식회사 에스지 SG SMART GEO',
      },
      breadcrumb: {
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: '홈',
            item: siteUrl,
          },
        ],
      },
    };

    const scriptId = 'schema-home';
    let script = document.getElementById(scriptId) as HTMLScriptElement | null;
    if (!script) {
      script = document.createElement('script');
      script.id = scriptId;
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify([organizationSchema, localBusinessSchema, webSiteSchema, webPageSchema]);

    document.title = '주식회사 에스지 SG SMART GEO | AI 기반 지반 데이터 분석 스마트 계측 전문기업';

    return () => {
      const el = document.getElementById(scriptId);
      if (el) el.remove();
    };
  }, []);

  return (
    <div className="min-h-screen" style={{ fontFamily: "'Noto Sans KR', sans-serif" }}>
      <Navbar />
      <main>
        <HeroSection />
        <CoreServicesSection />
        <CtaBanner />
      </main>
      <Footer />
    </div>
  );
};

export default Home;
